import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button, IconButton, TextField, CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";

const NewSentenceSection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, sentences: !expanded.sentences });
    };

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.sentences} onChange={() => handleToggle("sentences")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.sentence?.length || 0}) יצירת משפטים</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("sentence")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.sentence}
                    >
                        {loading.create.sentence ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Box>
                        {newInfo.sentence?.length > 0 ? (
                            newInfo.sentence.map((sentence, index) =>
                                <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", bgcolor: "#f0f0f0", p: 1, borderRadius: 2, mt: 0.5 }}>
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={sentence}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("sentence", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { sentence },
                                                    field: "sentences",
                                                    index
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.sentences?.[index]}
                                        >
                                            {sentence && (additionalInfo.loading.addExistsInfo.sentences?.[index] ? <CircularProgress size={24} /> : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("sentence", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={sentence}
                                        onChange={(e) => additionalInfo.editNewInfo("sentence", index, e.target.value)}
                                        sx={{ direction: /^[\u0590-\u05FF]/.test(sentence) ? "ltr" : "rtl" }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Typography variant="body2" color="textSecondary">לא נוצרו משפטים</Typography>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewSentenceSection;
